import { render, staticRenderFns } from "./FileMin.vue?vue&type=template&id=4ab2521a&scoped=true"
import script from "./FileMin.vue?vue&type=script&lang=js"
export * from "./FileMin.vue?vue&type=script&lang=js"
import style0 from "./FileMin.vue?vue&type=style&index=0&id=4ab2521a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2521a",
  null
  
)

export default component.exports